import { CountingValues } from "@types"
import { protectedApi } from "store/Api";

// Define the type for the arguments expected by your endpoint
interface FetchCountingValuesArgs {
    begin?: string;
    end?: string;
}

const countingValuesApi = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        fetchCountingValues: builder.mutation<CountingValues[], FetchCountingValuesArgs>({
            query: (date) => {
                return {
                    method: "GET",
                    url: `data/counting_values?start_date="${date.begin}"&end_date=${date.end}`,
                }
            }

        }),
    }),

})

export const { useFetchCountingValuesMutation } = countingValuesApi
